import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { createTrace } from 'stores/TraceStoreAdapter';

/**
 * 画面遷移を検知してトレースAPIを呼び出すルートコンポーネント。
 * - react-router の useLocation でパス変更を検知
 * - パスパラメータ・クエリパラメータを除去した正規化URLを送信
 * - 前回と同じURLの場合は送信しない（画面リロード扱い）
 */
const TraceRoute: React.FC = () => {
  const location = useLocation();
  const previousPathRef = React.useRef<string | null>(null);

  React.useEffect(() => {
    // パスパラメータ（動的セグメント）は除去せず、クエリパラメータとハッシュのみ除去
    // react-router の location.pathname にはクエリやハッシュは含まれないため、そのまま使用
    const currentPath = location.pathname;

    // 同じURLへの連続アクセス（画面リロード等）はログとして記録しない
    if (previousPathRef.current === currentPath) {
      return;
    }

    previousPathRef.current = currentPath;
    createTrace(currentPath);
  }, [location.pathname]);

  return <Outlet />;
};

export default TraceRoute;
